import { Component, Host, State, h } from '@stencil/core';
import { Unsubscribe, store } from '@stencil/redux';
import { OneClickIdChallenge, OneClickResponseInfo } from '../../class/class';
import { Language } from '../../enums/const-enums';
import { uiReady } from '../../redux/actions/config-actions';
import { RootState, initialStore } from '../../redux/store';
import { SignSubmit } from '../../service/sign-submit';
import { focusSignElement, handleErrorResponse } from '../../utils/utils';
import {
  RassOneClickIdTranslations,
  rassOneClickIdTranslations,
} from './i18n/rass-one-click-id.i18n';

@Component({
  tag: 'rass-one-click-id',
  styleUrl: 'rass-one-click-id.scss',
  shadow: false,
})
export class RassOneClickId {
  @State() assetsPath: string;
  @State() language: Language;
  @State() summary: string;
  @State() challengeData: OneClickIdChallenge;
  @State() isSubmitRequestPending: boolean;
  unsubscribe!: Unsubscribe;
  uiReady!: typeof uiReady;

  componentWillLoad(): void {
    store.setStore(initialStore);
    store.mapDispatchToProps(this, {
      uiReady,
    });
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      const {
        config: { assetsPath, summary, language },
        challengeData,
      } = state;
      return { assetsPath, summary, language, challengeData };
    });
  }

  componentDidLoad(): void {
    focusSignElement('submit-one-click-id', { preventScroll: true });
    this.uiReady();
  }

  submitChallengeId(): void {
    this.isSubmitRequestPending = true;
    const responseInfo = new OneClickResponseInfo(
      this.challengeData.challenge_id,
    );
    new SignSubmit()
      .doSignSubmit(responseInfo)
      .catch((error: AppModel.HttpResponseErrorJson) => {
        handleErrorResponse(error);
        this.isSubmitRequestPending = false;
      });
  }

  get translations(): RassOneClickIdTranslations {
    return (
      rassOneClickIdTranslations[this.language] ||
      rassOneClickIdTranslations[Language.EN]
    );
  }

  get summaryPlainText(): string {
    const elem = document.createElement('div');
    elem.innerHTML = this.summary;
    elem.querySelectorAll('style').forEach((style) => style.remove());
    return elem.innerText;
  }

  render(): void {
    return (
      <Host class="section-one-click-id">
        <style>@import url({`'${this.assetsPath}css/rds-style.css'`});</style>
        <div class="rds-container body-width" role="form">
          <div class="rds-row rds-justify-content-center rds-margin-block-end-300">
            <div class="rds-col-xs-12 rds-col-sm-6">
              <rds-button
                id="submit-one-click-id"
                variant="primary"
                disabled={this.isSubmitRequestPending}
                onRdsClick={(): void => this.submitChallengeId()}
                aria-label={`${this.translations.button.text}: ${this.summaryPlainText}`}
              >
                {this.translations.button.text}
              </rds-button>
            </div>
          </div>
        </div>
      </Host>
    ) as void;
  }
}
